class DataPackage {
    constructor({ userId, owner, portfolios, transactions, mergedPositions, portfoliosTotalAmount, portfoliosChangeInfo, packageMetadata }) {
        this._userId = userId
        this._owner = owner
        this._portfolios = portfolios
        this._transactions = transactions
        this._mergedPositions = mergedPositions
        this._portfoliosTotalAmount = portfoliosTotalAmount
        this._portfoliosChangeInfo = portfoliosChangeInfo
        this._packageMetadata = packageMetadata
    }

    get userId() {
        return this._userId
    }

    get owner() {
        return this._owner
    }

    get portfolios() {
        return this._portfolios
    }

    get transactions() {
        return this._transactions
    }

    get positions() {
        return this._mergedPositions
    }

    get aggregatedPortfolioStock() {
        return this._mergedPositions
    }

    get portfoliosChangeInfo() {
        return {
            value: this._portfoliosTotalAmount.value,
            currency: this._portfoliosTotalAmount.currency,
            change: {
                val: this._portfoliosChangeInfo.changeAmount.value,
                chg: this._portfoliosChangeInfo.changePercent,
                chgSymbol: "%",
                inverted: true
            }
        }
    }

    get sharingOptions() {
        return this._packageMetadata.sharingOptions
    }

    get total() {
        return {
            ...this._portfolios,
            totalChangeConverted: {
                val: 4567.89,
                chg: 2.34,
                chgSymbol: "%",
                inverted: true
            }
        }
    }

    // get totalChangeConverted() {
    //     return {
    //         val: 4567.89,
    //         chg: 2.34,
    //         chgSymbol: "%",
    //         inverted: true
    //     }
    // }

    get hasPortfoliosTotalAmount() {
        return this._portfolios
    }

    get hasTransactions() {
        return this._transactions && Array.isArray(this._transactions)
    }
}

export default DataPackage

// this.friendData = {
//     owner: 'friend',
//     aggregatedPortfolioStock: data.portfolioSummary.aggregatedPortfolioStock,
//     total: {
//         portfolioSummary: data.portfolioSummary
//     },
//     transactions: data.transactions ? data.transactions : [],
//     positions: data.userMergedStockPositions ? data.userMergedStockPositions : []
// }